import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider, QueryProvider, clearLegacyAuthStorage } from '@flexibilitypay/shared';
import { App } from './app';
import { resources } from './i18n';
import './styles/index.css';

clearLegacyAuthStorage();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider resources={resources}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </I18nProvider>
  </StrictMode>,
);
